<template>
  <section class="pricing" id="pricing">
    <div class="container">
      <div class="col-12">
        <div class="title">
          <h1 class="mb-4">{{ t('Choose Your Subscription Plan') }}</h1>
          <p>{{ t("Paying less doesn't always mean getting less. Here at Veximus, you can still enjoy FREE premium web hosting, FREE domain name, FREE SSL certificate and FREE business emails, even when you sign up for the lowest price plan.") }}</p>
        </div>
        <ul class="switch" @click="toggleSwitch($event)" :data-switch="billingCycleSwitch" :data-selection="billingCycleSwitch ? t('Yearly') : t('Monthly')">
          <li>{{ t('Monthly') }}</li>
          <li>{{ t('Yearly') }}</li>
        </ul>
        <splide class="carousel" :options="sliderOptions">
          <splide-slide>
            <div class="card">
              <div class="row">
                <div class="col-12">
                  <div class="d-lg-flex">
                    <img src="images/ui/pricings/startup.svg" alt="{{ t('Startup Plan') }}" />
                    <div class="info">
                      <h3>{{ t('Startup Plan') }}</h3>
                      <p>{{ t('Best for startup businesses, and small companies to showcase their ideas.') }}</p>
                    </div>
                    <div class="price">
                      <h1>{{ !billingCycleSwitch ? '98' : '58' }}</h1>
                      <h6>{{ t('MYR/Month') }}</h6>
                      <p>({{ t('Billed') }} {{ !billingCycleSwitch ? t('Monthly') : t('Anually') }})</p>
                    </div>
                  </div>
                </div>
                <hr />
                <div class="col-md-6">
                  <ul>
                    <li>
                      <font-awesome-icon icon="check" />
                      {{ t('{n} Main Page', 1) }} + {{ t('{n} Subpage', 0) }}
                    </li>
                    <li>
                      <font-awesome-icon icon="check" />
                      {{ t('∞ Revisions') }}
                    </li>
                    <li>
                      <font-awesome-icon icon="check" />
                      {{ t('Free Web Hosting') }}
                    </li>
                    <li>
                      <font-awesome-icon icon="check" />
                      {{ t('Free Top-Level Domain') }}
                    </li>
                    <li>
                      <font-awesome-icon icon="check" />
                      {{ t('Free SSL Certificate') }}
                    </li>
                    <li>
                      <font-awesome-icon icon="check" />
                      {{ t('Free CDN Services') }}
                    </li>
                  </ul>
                </div>
                <div class="col-md-6">
                  <ul>
                    <li>
                      <font-awesome-icon icon="check" />
                      {{ t('Free {n} Business Email', 1) }}
                    </li>
                    <li>
                      <font-awesome-icon icon="check" />
                      {{ t('Free Website Analytics') }}
                    </li>
                    <li>
                      <font-awesome-icon icon="check" />
                      {{ t('Free Technical Support') }}
                    </li>
                    <li>
                      <font-awesome-icon icon="times" />
                      {{ t('Free Weekly Backups') }}
                    </li>
                    <li>
                      <font-awesome-icon icon="times" />
                      {{ t('Free MySQL Database') }}
                    </li>
                    <li>
                      <font-awesome-icon icon="times" />
                      {{ t('Source Code Repository') }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </splide-slide>
          <splide-slide>
            <div class="card">
              <div class="row">
                <div class="col-12">
                  <div class="d-lg-flex">
                    <img src="images/ui/pricings/growth.svg" alt="{{ t('Growth Plan') }}" />
                    <div class="info">
                      <h3 :data-tag="t('Most Popular')">{{ t('Growth Plan') }}</h3>
                      <p>{{ t('Great for growing businesses who want a professional image and improve their branding.') }}</p>
                    </div>
                    <div class="price">
                      <h1>{{ !billingCycleSwitch ? '258' : '118' }}</h1>
                      <h6>{{ t('MYR/Month') }}</h6>
                      <p>({{ t('Billed') }} {{ !billingCycleSwitch ? t('Monthly') : t('Anually') }})</p>
                    </div>
                  </div>
                </div>
                <hr />
                <div class="col-md-6">
                  <ul>
                    <li>
                      <font-awesome-icon icon="check" />
                      {{ t('{n} Main Page', 7) }} + {{ t('∞ Subpages') }}
                    </li>
                    <li>
                      <font-awesome-icon icon="check" />
                      {{ t('∞ Revisions') }}
                    </li>
                    <li>
                      <font-awesome-icon icon="check" />
                      {{ t('Free Web Hosting') }}
                    </li>
                    <li>
                      <font-awesome-icon icon="check" />
                      {{ t('Free Top-Level Domain') }}
                    </li>
                    <li>
                      <font-awesome-icon icon="check" />
                      {{ t('Free SSL Certificate') }}
                    </li>
                    <li>
                      <font-awesome-icon icon="check" />
                      {{ t('Free CDN Services') }}
                    </li>
                  </ul>
                </div>
                <div class="col-md-6">
                  <ul>
                    <li>
                      <font-awesome-icon icon="check" />
                      {{ t('Free {n} Business Email', 5) }}
                    </li>
                    <li>
                      <font-awesome-icon icon="check" />
                      {{ t('Free Website Analytics') }}
                    </li>
                    <li>
                      <font-awesome-icon icon="check" />
                      {{ t('Free Technical Support') }}
                    </li>
                    <li>
                      <font-awesome-icon icon="check" />
                      {{ t('Free Weekly Backups') }}
                    </li>
                    <li>
                      <font-awesome-icon icon="times" />
                      {{ t('Free MySQL Database') }}
                    </li>
                    <li>
                      <font-awesome-icon icon="times" />
                      {{ t('Source Code Repository') }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </splide-slide>
          <splide-slide>
            <div class="card">
              <div class="row">
                <div class="col-12">
                  <div class="d-lg-flex">
                    <img src="images/ui/pricings/custom.svg" alt="{{ t('Custom Plan') }}" />
                    <div class="info">
                      <h3>{{ t('Custom Plan') }}</h3>
                      <p>{{ t('Suitable for businesses who would like more customisations to fit their business requirements.') }}</p>
                    </div>
                    <div class="price">
                      <font-awesome-icon icon="quote-right" />
                      <h6>{{ t('Request Quote') }}</h6>
                      <p>({{ t('Contact Us') }})</p>
                    </div>
                  </div>
                </div>
                <hr />
                <div class="col-md-6">
                  <ul>
                    <li>
                      <font-awesome-icon icon="check" />
                      {{ t('∞ Main Pages') }} + {{ t('∞ Subpages') }}
                    </li>
                    <li>
                      <font-awesome-icon icon="check" />
                      {{ t('∞ Revisions') }}
                    </li>
                    <li>
                      <font-awesome-icon icon="check" />
                      {{ t('Free Web Hosting') }}
                    </li>
                    <li>
                      <font-awesome-icon icon="check" />
                      {{ t('Free Top-Level Domain') }}
                    </li>
                    <li>
                      <font-awesome-icon icon="check" />
                      {{ t('Free SSL Certificate') }}
                    </li>
                    <li>
                      <font-awesome-icon icon="check" />
                      {{ t('Free CDN Services') }}
                    </li>
                  </ul>
                </div>
                <div class="col-md-6">
                  <ul>
                    <li>
                      <font-awesome-icon icon="check" />
                      {{ t('Free {n} Business Email', 10) }}
                    </li>
                    <li>
                      <font-awesome-icon icon="check" />
                      {{ t('Free Website Analytics') }}
                    </li>
                    <li>
                      <font-awesome-icon icon="check" />
                      {{ t('Free Technical Support') }}
                    </li>
                    <li>
                      <font-awesome-icon icon="check" />
                      {{ t('Free Daily Backups') }}
                    </li>
                    <li>
                      <font-awesome-icon icon="check" />
                      {{ t('Free MySQL Database') }}
                    </li>
                    <li>
                      <font-awesome-icon icon="check" />
                      {{ t('Source Code Repository') }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </splide-slide>
        </splide>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
@import '~/_variables.scss';

.pricing {
  background: #fbfbfb;
  text-align: center;

  .title {
    margin: 0 auto 2rem;
    max-width: 600px;
    text-align: center;
  }

  .switch {
    background: #eee;
    border-radius: 5rem;
    border: solid 2px #eee;
    cursor: pointer;
    display: inline-flex;
    font-weight: 500;
    margin-bottom: 2rem;
    position: relative;
    user-select: none;

    &::after {
      align-items: center;
      background: linear-gradient(90deg, $primary, #00a0ff);
      border-radius: 5rem;
      box-shadow: 0 0 0.5rem rgb(0 0 0 / 10%);
      color: #fff;
      content: attr(data-selection);
      justify-content: center;
      padding: 0.5rem;
      position: absolute;
      transform: translateX(0%);
      transition: transform 0.25s;
      width: 100px;
    }

    &[data-switch='true'] {
      &::after {
        transform: translateX(100%);
      }
    }

    li {
      padding: 0.5rem 1rem;
      width: 100px;
    }
  }

  .carousel {
    .card {
      border-radius: 0.5rem;
      box-shadow: 0 0.25rem 0.25rem 0 rgb(25 25 25 / 5%);
      margin: 1rem 0.5rem;
      overflow: hidden;
      padding: 1.5rem 3rem 1.5rem 4rem;
      text-align: left;

      &::before {
        background: $primary;
        box-shadow: inset -0.5rem 0 1rem rgb(0 0 0 / 15%);
        content: '';
        height: 100%;
        left: 0;
        position: absolute;
        top: 0;
        width: 30px;
      }

      img {
        height: 75px;
        margin-right: 2rem;

        @media (max-width: 991.98px) {
          margin-bottom: 2rem;
        }
      }

      .info {
        max-width: 100%;
        width: 400px;

        h3 {
          display: inline-block;
          position: relative;

          &[data-tag]::after {
            background: #fd0d6e;
            border-radius: 0.25rem;
            box-shadow: 0 0.25rem 0.5rem rgb(253 13 110 / 25%);
            color: #fff;
            content: attr(data-tag);
            font-family: 'Roboto', sans-serif;
            font-size: 0.75rem;
            font-weight: 500;
            left: calc(100% + 1.5rem);
            letter-spacing: 0;
            line-height: 1rem;
            padding: 0.25rem 0.75rem;
            position: absolute;
            top: 0.1rem;
            width: fit-content;

            @media (max-width: 991.98px) {
              display: block;
              margin-top: 0.5rem;
              position: unset;
            }
          }
        }
      }

      .price {
        min-width: 150px;
        position: absolute;
        right: 1.25rem;
        text-align: center;
        top: 1.25rem;

        h1 {
          background: linear-gradient(90deg, $primary, #00a0ff);
          color: transparent;
          font-size: 4rem;
          line-height: 3rem;
          margin-bottom: 0.25rem;
          background-clip: text;
        }

        h6 {
          margin-bottom: 0;
        }

        p {
          color: #999;
          font-size: 0.75rem;
          line-height: 0.75rem;
          margin-bottom: 0;
        }

        svg {
          color: #0788fe;
          font-size: 3.25rem;
        }

        @media (max-width: 991.98px) {
          min-width: auto;
          right: 1.5rem;
        }
      }

      ul {
        li {
          align-items: center;
          display: flex;

          svg {
            border-radius: 50%;
            height: 15px;
            margin-right: 1rem;
            padding: 0.2rem;
            width: 15px;

            &.fa-check {
              background: linear-gradient(90deg, $primary, #00a0ff);
              color: #fff;
            }

            &.fa-times {
              background: #eee;
              color: #ccc;
            }
          }
        }
      }

      @media (max-width: 767.98px) {
        padding: 1.5rem 1rem 1.5rem 3rem;
      }
    }
  }
}
</style>

<script>
import '@splidejs/splide/dist/css/themes/splide-default.min.css';
import { Splide, SplideSlide } from '@splidejs/vue-splide';
import { useI18n } from 'vue-i18n';
import VanillaTilt from 'vanilla-tilt';

export default {
  components: {
    Splide,
    SplideSlide
  },

  data() {
    return {
      billingCycleSwitch: true,
      sliderOptions: {
        arrows: false,
        autoplay: true,
        focus: 'center',
        gap: '1rem',
        padding: '5rem',
        pagination: false,
        perPage: 1,
        rewind: true,
        breakpoints: {
          992: {
            destroy: true
          }
        }
      }
    };
  },

  methods: {
    toggleSwitch: _.debounce(function () {
      this.billingCycleSwitch = !this.billingCycleSwitch;
    }, 100),

    handleResize: _.debounce(function () {
      if (window.innerWidth < 992) {
        document.querySelector('.splide__list').style.width = '100%';
      }
    }, 100)
  },

  created() {
    window.addEventListener('resize', this.handleResize);
  },

  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize);
  },

  mounted() {
    this.handleResize();
    VanillaTilt.init(document.querySelectorAll('.pricing .carousel .card'), {
      'max-glare': 0.25,
      glare: true,
      max: 1,
      scale: 1
    });
  },

  setup() {
    const { t } = useI18n({
      messages: {
        'en-MY': {
          '{n} Main Page': '1 Main Page | {n} Main Pages',
          '{n} Subpage': '0 Subpage | 1 Subpage | {n} Subpages',
          'Best for startup businesses, and small companies to showcase their ideas.': 'Best for startup businesses, and small companies to showcase their ideas.',
          'Choose Your Subscription Plan': 'Choose Your Subscription Plan',
          'Contact Us': 'Contact Us',
          'Custom Plan': 'Custom Plan',
          'Free {n} Business Email': 'Free 1 Business Email | Free {n} Business Emails',
          'Free CDN Services': 'Free CDN Services',
          'Free Daily Backups': 'Free Daily Backups',
          'Free MySQL Database': 'Free MySQL Database',
          'Free SSL Certificate': 'Free SSL Certificate',
          'Free Technical Support': 'Free Technical Support',
          'Free Top-Level Domain': 'Free Top-Level Domain',
          'Free Web Hosting': 'Free Web Hosting',
          'Free Website Analytics': 'Free Website Analytics',
          'Free Weekly Backups': 'Free Weekly Backups',
          'Great for growing businesses who want a professional image and improve their branding.': 'Great for growing businesses who want a professional image and improve their branding.',
          'Growth Plan': 'Growth Plan',
          'Most Popular': 'Most Popular',
          'MYR/Month': 'MYR/Month',
          'Request Quote': 'Request Quote',
          'Source Code Repository': 'Source Code Repository',
          'Startup Plan': 'Startup Plan',
          'Suitable for businesses who would like more customisations to fit their business requirements.': 'Suitable for businesses who would like more customisations to fit their business requirements.',
          '∞ Main Pages': '∞ Main Pages',
          '∞ Revisions': '∞ Revisions',
          '∞ Subpages': '∞ Subpages',
          "Paying less doesn't always mean getting less. Here at Veximus, you can still enjoy FREE premium web hosting, FREE domain name, FREE SSL certificate and FREE business emails, even when you sign up for the lowest price plan.": "Paying less doesn't always mean getting less. Here at Veximus, you can still enjoy FREE premium web hosting, FREE domain name, FREE SSL certificate and FREE business emails, even when you sign up for the lowest price plan.",
          Anually: 'Anually',
          Billed: 'Billed',
          Monthly: 'Monthly',
          Yearly: 'Yearly'
        },
        'zh-MY': {
          '{n} Main Page': '{n} 主页面',
          '{n} Subpage': '{n} 子页面',
          'Best for startup businesses, and small companies to showcase their ideas.': '我们所提供的启动配套适合想要完美地呈现出自己独特概念的新兴企业以及小公司。',
          'Choose Your Subscription Plan': '选择属于您的订阅配套',
          'Contact Us': '联系我们',
          'Custom Plan': '客制配套',
          'Free {n} Business Email': '免费 {n} 商务电子邮箱',
          'Free CDN Services': '免费 CDN服务',
          'Free Daily Backups': '免费 每日云端备份',
          'Free MySQL Database': '免费 MySQL数据库',
          'Free SSL Certificate': '免费 SSL认证',
          'Free Technical Support': '免费 技术支援',
          'Free Top-Level Domain': '免费 顶级域名',
          'Free Web Hosting': '免费 网络托管',
          'Free Website Analytics': '免费 网站数据分析',
          'Free Weekly Backups': '免费 每周云端备份',
          'Great for growing businesses who want a professional image and improve their branding.': '我们所提供的成长配套适合想要拥有专业形象，并且希望能够改善其品牌的成长中企业。',
          'Growth Plan': '成长配套',
          'Most Popular': '最受欢迎',
          'MYR/Month': 'MYR/每月',
          'Request Quote': '要求报价',
          'Source Code Repository': '源代码储存库',
          'Startup Plan': '启动配套',
          'Suitable for businesses who would like more customisations to fit their business requirements.': '我们所提供的客制配套适合想要拥有更多客制化服务的大型企业，让他们的站点完美迎合仅属于他们的生意诉求。',
          '∞ Main Pages': '∞ 主页面',
          '∞ Revisions': '∞ 内容修订',
          '∞ Subpages': '∞ 子页面',
          "Paying less doesn't always mean getting less. Here at Veximus, you can still enjoy FREE premium web hosting, FREE domain name, FREE SSL certificate and FREE business emails, even when you sign up for the lowest price plan.": '支付更少的费用并不意味着得到更少的服务，在微星，即便你签订的是最低价格的订阅配套，你也一样能够享受免费的网络托管服务，免费的顶级域名，免费的SSL认证，以及免费的商务电子邮箱。',
          Anually: '每年',
          Billed: '收费间隔',
          Monthly: '每月',
          Yearly: '每年'
        },
        'ms-MY': {
          '{n} Main Page': '{n} Laman Utama',
          '{n} Subpage': '{n} Laman Sekunder',
          'Best for startup businesses, and small companies to showcase their ideas.': 'Sesuai untuk perusahanan permulaan, dan syarikat-syarikat kecil untuk mempamerkan idea-idea mereka.',
          'Choose Your Subscription Plan': 'Pilih Pelan Langganan Anda',
          'Contact Us': 'Hubungi Kami',
          'Custom Plan': 'Pelan "Custom"',
          'Free {n} Business Email': '{n} E-mel Business Percuma',
          'Free CDN Services': 'Servis CDN Percuma',
          'Free Daily Backups': 'Sandaran Harian Percuma',
          'Free MySQL Database': 'Pangkalan Data MySQL Percuma',
          'Free SSL Certificate': 'Sijil SSL Percuma',
          'Free Technical Support': 'Sokongan Teknikal Percuma',
          'Free Top-Level Domain': 'Domain Peringkat Atasan Percuma',
          'Free Web Hosting': 'Hosting Web Percuma',
          'Free Website Analytics': 'Analisis Laman Web Percuma',
          'Free Weekly Backups': 'Sandaran Mingguan Percuma',
          'Great for growing businesses who want a professional image and improve their branding.': 'Sesuai untuk perusahanan yang ingin meningkatkan imej profesional dan jenama mereka.',
          'Growth Plan': 'Pelan "Growth"',
          'Most Popular': 'Paling Popular',
          'MYR/Month': 'MYR/bulan',
          'Request Quote': 'Minta Sebut Harga',
          'Source Code Repository': 'Repositori Kod Asal',
          'Startup Plan': 'Pelan "Startup"',
          'Suitable for businesses who would like more customisations to fit their business requirements.': 'Sesuai untuk perusahanan yang ingin dapat penyesuaian untuk memenuhi keperluan mereka.',
          '∞ Main Pages': '∞ Laman Utama',
          '∞ Revisions': '∞ Ulang Kaji',
          '∞ Subpages': '∞ Laman Sekunder',
          "Paying less doesn't always mean getting less. Here at Veximus, you can still enjoy FREE premium web hosting, FREE domain name, FREE SSL certificate and FREE business emails, even when you sign up for the lowest price plan.": 'Harga yang lebih rendah tidak semestinya bermakna kekurangan kualiti. Dengan Veximus, anda masih boleh menikmati hosting web PERCUMA, domain PERCUMA, sijil SSL PERCUMA dan e-mel business PERCUMA dengan pelan yang paling murah.',
          Anually: 'Tahunan',
          Billed: 'Bayaran',
          Monthly: 'Bulanan',
          Yearly: 'Tahunan'
        }
      }
    });

    return { t };
  }
};
</script>
